import React, { useState, lazy, Suspense } from 'react';
import styled from 'styled-components';
import TopNavigation from './TopNavigation';
import ProfileSection from './ProfileSection';
import DotLoader from './DotLoader';
const ProjectsSection = lazy(() => import('./ProjectsSection'));
const AppsSection = lazy(() => import('./AppsSection'));
const DonateSection = lazy(() => import('./DonateSection'));
const AboutMeSection = lazy(() => import('./AboutMeSection'));
const FAQSection = lazy(() => import('./FAQSection'));
const ContactSection = lazy(() => import('./ContactSection'));

const PageContainer = styled.main`
  width: min(100%, 1200px);
  margin: 0 auto;
  padding: calc(${props => props.theme.ui.navHeight} + clamp(1rem, 3vw, 2.5rem)) clamp(1rem, 3vw, 2.5rem) clamp(1rem, 3vw, 2.5rem);
  animation: fadeIn calc(0.5s * var(--motion-duration-scale, 1))
    ease-in-out;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.lg};
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: ${props => props.theme.colors.textLighter};
  font-size: 0.9rem;
`;

const sectionFallback = (
  <LoadingSpinner>
    <DotLoader />
  </LoadingSpinner>
);

const MainPageLayout = () => {
  const [activeSection, setActiveSection] = useState('CODING');

  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <TopNavigation />
      <PageContainer id="main-content">
        <ProfileSection activeSection={activeSection} setActiveSection={setActiveSection} />
        <Suspense fallback={sectionFallback}>
          {activeSection === 'CODING' && <ProjectsSection />}
        </Suspense>
        <Suspense fallback={sectionFallback}>
          <AppsSection />
        </Suspense>
        <Suspense fallback={sectionFallback}>
          <DonateSection />
        </Suspense>
        <Suspense fallback={sectionFallback}>
          <AboutMeSection />
        </Suspense>
        <Suspense fallback={sectionFallback}>
          <FAQSection />
        </Suspense>
        <Suspense fallback={sectionFallback}>
          <ContactSection />
        </Suspense>
      </PageContainer>
    </>
  );
};

export default MainPageLayout;